import { Ability, AbilityBuilder, AbilityClass } from '@casl/ability'

import { IUser } from 'redux/store/user/types'
import {
  Conditions,
  VendorsAbility,
  VendorsAbilityBuilder,
  PossibleAbilities
} from 'features/MyCommunity/Vendors/Abilities/types'
import {
  ACTIONS,
  SUBJECTS
} from 'features/MyCommunity/Vendors/Abilities/constants'
import { rolesForUpgrade } from '../VendorsList/Menu/constants'
import { ROLES } from 'features/Permission'

const VendorsAbilityClass = Ability as AbilityClass<VendorsAbility>

export const ability = new Ability<PossibleAbilities, Conditions>()

export default (user: IUser) => {
  const builder = new AbilityBuilder(VendorsAbilityClass)

  // Define basic abilities for all users
  defineBasicAbilities(builder, user)

  return new Ability(builder.rules) as VendorsAbility
}

const defineBasicAbilities = (builder: VendorsAbilityBuilder, user: IUser) => {
  // Basic view permissions for all authenticated users
  builder.can(ACTIONS.VIEW, SUBJECTS.VENDORS)
  builder.can(ACTIONS.VIEW, SUBJECTS.VENDOR_DETAILS)
  builder.can(ACTIONS.VIEW, SUBJECTS.VENDOR_USERS)

  // Sub-tab view permissions granted to all users by default
  builder.can(ACTIONS.VIEW, SUBJECTS.MY_VENDORS)
  builder.can(ACTIONS.VIEW, SUBJECTS.VENDORS_REPOSITORY)

  // Community Finance may not access the Vendors Repository sub-tab
  if (user?.role === ROLES.FINANCE) {
    builder.cannot(ACTIONS.VIEW, SUBJECTS.VENDORS_REPOSITORY)
  }

  // Upgrade permission based on user role
  if (rolesForUpgrade.includes(user?.role)) {
    builder.can(ACTIONS.UPGRADE, SUBJECTS.VENDOR_PERMISSION)
  }
}
